import {Checkpoint} from './checkpoint';
import {Company} from './company';
import {Server} from './server';
import {AzureLinkedFeature} from './azurefeature';

export class Platform {
    id: number;
    company_id: number;
    responsible_user_id?: number;
    fallback_responsible_user_id?: number;
    name: string;

    prod_url?: string;
    prod_server_ip?: string;
    acc_url?: string;
    acc_server_ip?: string;
    test_url?: string;
    test_server_ip?: string;
    local_url?: string;
    start_date: Date;
    end_date?: Date;
    description?: string;

    software_info?: string

    updated_at: Date;
    deleted_at?: Date;

    company?: Company;

    checkpoint_production_count?: number;
    checkpoint_production_error_count?: number;
    checkpoint_production_warning_count?: number;
    checkpoint_production_postpone_count?: number;
    checkpoint_production_last_instance?: Checkpoint[];
    checkpoint_health_count?: number;
    checkpoint_health_error_count?: number;
    checkpoint_health_warning_count?: number;
    checkpoint_health_postpone_count?: number;
    checkpoint_health_last_instance?: Checkpoint[];
    checkpoint_check_count?: number;
    checkpoint_check_error_count?: number;
    checkpoint_check_warning_count?: number;
    checkpoint_check_postpone_count?: number;
    checkpoint_check_last_instance?: Checkpoint[];
    checkpoint_acceptance_count?: number;
    checkpoint_acceptance_error_count?: number;
    checkpoint_acceptance_warning_count?: number;
    checkpoint_acceptance_postpone_count?: number;
    checkpoint_acceptance_last_instance?: Checkpoint[];

    prod_server?: Server;
    acc_server?: Server;
    test_server?: Server;

    closest_ssl_expiry_date?: Date;
    closest_acceptance_ssl_expiry_date?: Date;

    azure_features?: AzureLinkedFeature[];
}
